/** Run ``work`` over every item, at most ``limit`` at once, in order; one failure never stops
 * the rest (spec 4 §1: past papers upload two at a time). */
export async function runQueue<T>(
  items: T[],
  limit: number,
  work: (item: T) => Promise<void>,
): Promise<void> {
  let next = 0;
  const lane = async () => {
    while (next < items.length) {
      const item = items[next++] as T;
      try {
        await work(item);
      } catch {
        // The worker reports its own failure; the queue carries on.
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, lane));
}
